import React, {useState, useEffect} from "react";

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

import Image from 'material-ui-image'
import ImageEditor from "./ImageEditor";
import CreateIcon from '@material-ui/icons/Create';
import DeleteIcon from '@material-ui/icons/Delete';
import {makeStyles, IconButton, Typography} from "@material-ui/core";
import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles((theme) => ({
    gallery: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridGap: theme.spacing(2),
        maxHeight: 'calc(100vh - 320px)',
        overflowY: 'auto',
        '& > img': {
            borderRadius: theme.shape.borderRadius,
            width: 200,
            margin: 'auto',
        }
    },
    gridImage: {
        position: 'relative',
        '& .image-actions': {
            opacity: 0,
            position: 'absolute',
            top: 0,
            right: 0,
            background: '#32373D',
            borderBottomLeftRadius: 16,
            transition: theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        '&:hover .image-actions': {
            opacity: 1,
        }

    },
    mainCarousel: {
        position: 'relative',
        padding: '0 100px',
        marginBottom: 32,
    },
    carouselWrapper: {
        '& .alice-carousel__stage-item': {
            transition: theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        '& .alice-carousel__stage-item.__active.__target': {
            transform: "scale(1.1)",

        },
        // overflowx:'scroll'
    },
    carouselButton: {
        top: `calc(50vh - 75%)`,
        height: '60%',
        borderRadius: 5,
        boxShadow: '0 4px 4px #000',
        background: '#404246',
        position: 'absolute',
    }
}))


const mainCarouselHeight = 'calc(100vh - 482px)';
export default function ImageSetEditor({images, handleUpdate, updateTime, onEditing, handleDelete}) {
    const classes = useStyles();
    const [isEditing, setIsEditing] = useState(false);
    const [viewType, setViewType] = useState('grid')
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [thumbs, setThumbs] = useState([]);
    const [carouselItems, setCarouselItems] = useState([]);
    const [mainAnimation, setMainAnimation] = useState(false);
    const [thumbIndex, setThumbIndex] = useState(0);
    const [thumbAnimation, setThumbAnimation] = useState(false);

    useEffect(() => {
        setThumbs(images.map((image, i) => (
            <div style={{width: 128, height: 128, padding: 8, cursor: 'pointer'}} onClick={() => {setThumbIndex(i); setThumbAnimation(true)}} key={`stage_${i}` + image.ts_update}>
                <Image src={image.editedUri} color="#404246"
                    style={{width: '100%', height: '100%', borderRadius: 16, boxShadow: '0 4px 4px #000'}} alt="thumb" />
            </div>
        )))
        setCarouselItems(images.map((image, i) => (
            <div style={{height: mainCarouselHeight, objectFit: 'contain', width: '100%', overflow: 'hidden', textAlign: 'center'}} key={`thumb_${i}` + image.ts_update}>
                <Image src={image.editedUri} aspectRatio={1}
                    imageStyle={{objectFit: 'contain', height: mainCarouselHeight, width: '100%', boxShadow: '0 4px 4px #000'}}
                    color="#2f3135" alt="stage" />
            </div>
        )));
    }, [images, updateTime])

    const slideNext = () => {
        if (!thumbAnimation && thumbIndex < thumbs.length - 1) {
            setThumbAnimation(true);
            setThumbIndex(thumbIndex + 1);
        }
    };

    const slidePrev = () => {
        if (!thumbAnimation && thumbIndex > 0) {
            setThumbAnimation(true);
            setThumbIndex(thumbIndex - 1);
        }
    };

    const syncMainBeforeChange = (e) => {setMainAnimation(true);};

    const syncMainAfterChange = (e) => {
        setMainAnimation(false);
        if (e.type === 'action') {
            setThumbIndex(e.item);
            setThumbAnimation(false);
        } else {
            setSelectedImageIndex(thumbIndex);
        }
    };

    const syncThumbs = (e) => {
        setThumbIndex(e.item);
        setThumbAnimation(false);

        if (!mainAnimation) {
            setSelectedImageIndex(e.item);
        }
    };

    useEffect(() => {
        onEditing(isEditing);
    }, [isEditing, onEditing])


    if (isEditing && images && selectedImageIndex > -1 && selectedImageIndex < images.length) {
        return (
            <ImageEditor
                image={images[selectedImageIndex]}
                onControlsToggle={(s) => setIsEditing(s)}
                isEditing={isEditing}
                editorHeight={600}
                outputHeight={450}
                aspectRatio={1}
                exportType="image/jpeg"
                handleCancel={() => setIsEditing(false)}
                handleUpdate={(image) => {handleUpdate(selectedImageIndex, image); setIsEditing(false)}}
            />
        );
    }

    const handleEditClick = (index) => {
        setSelectedImageIndex(index);
        setIsEditing(true);
    }

    const handleDeleteClick = (index) => {
        handleDelete(index)
    }

    const ViewToggles = () => {
        return (
            <div>
                <IconButton onClick={() => setViewType('grid')} style={{color: viewType === 'grid' ? "#FF007F" : "#fff"}}><ViewComfyIcon /></IconButton>
                <IconButton onClick={() => setViewType('carousel')} style={{color: viewType === 'carousel' ? "#FF007F" : "#fff"}}><ViewCarouselIcon /></IconButton>
            </div>
        )
    }

    const ImageActions = ({i}) => {
        return (
            <div className="image-actions">
                <IconButton onClick={() => handleEditClick(i)} style={{color: "#fff"}}><CreateIcon /></IconButton>
                <IconButton onClick={() => handleDeleteClick(i)} style={{color: "tomato"}}><DeleteIcon /></IconButton>
            </div>
        )
    }

    if (viewType === 'grid') {
        return (
            <div style={{height: '100%', position: 'relative', width: '100%'}}>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 8}}>
                    <ViewToggles />
                    <div style={{flex: '1'}} />
                    <Typography>Hover on the picture to edit or delete the picture</Typography>
                </div>

                <div className={classes.gallery}>
                    {images.map((image, i) => (
                        <div className={classes.gridImage} key={image._id}>
                            <Image aspectRatio={1}
                                color="#32373D"
                                style={{objectFit: 'contain', borderRadius: '10px'}}
                                key={image.editedUri}
                                src={image.editedUri} alt="grid item" />
                            <ImageActions i={i} />
                        </div>
                    ))}
                </div>
            </div>
        )
    }



    if (viewType === 'carousel') {
        return (
            <div style={{height: '100%', position: 'relative', width: '100%', display: 'flex', flexDirection: 'column'}} >
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 8}}>
                    <ViewToggles />
                    <div style={{flex: '1'}} />
                    <ImageActions i={selectedImageIndex} />
                </div>
                <div className={classes.mainCarousel} style={{flex: '1'}}>
                    <AliceCarousel
                        activeIndex={selectedImageIndex}
                        animationType="slide"
                        animationDuration={400}
                        disableDotsControls
                        disableButtonsControls
                        infinite
                        items={carouselItems}
                        mouseTracking={false}
                        onSlideChange={syncMainBeforeChange}
                        onSlideChanged={syncMainAfterChange}
                        touchTracking={!thumbAnimation}
                    />
                    <IconButton onClick={slidePrev} className={classes.carouselButton} style={{left: 0}} disabled={selectedImageIndex === 0}>
                        <ArrowBackIcon />
                    </IconButton>
                    <IconButton onClick={slideNext} className={classes.carouselButton} style={{right: 0}} disabled={selectedImageIndex === carouselItems.length - 1}>
                        <ArrowForwardIcon />
                    </IconButton>
                </div>
                <div className={classes.carouselWrapper}>
                    <AliceCarousel
                        activeIndex={thumbIndex}
                        autoWidth
                        disableDotsControls
                        disableButtonsControls
                        items={thumbs}
                        mouseTracking={false}
                        onSlideChanged={syncThumbs}
                        touchTracking={!mainAnimation}
                    />
                </div>
            </div>
        )
    }

    return null;

}
